// Download translations by locale.
//
// The set of translations can be limited by providing a list of context keys.
// If no context keys are given the full set of translations for the requested
// locale is returned.
export const TranslationService_DownloadLazy = () =>
  import("./service.grpc").then((m) => m.TranslationService_Download);
TranslationService_DownloadLazy.method =
  "aysa_api.services.translation.v1.TranslationService/Download" as const;
